import React from "react"

import classNames from "src/classNames"

type CardProps = {
  title: React.ReactNode
  description: string
  onClick?: VoidFunction
  href?: string
}

const Card: React.FC<CardProps> = ({ title, description, onClick, href }) => {
  return (
    <div className="flex flex-col justify-between rounded-3xl p-8 ring-2 ring-sky-600">
      <h2 className="text-lg/8 mt-0 font-semibold text-sky-600">{title}</h2>
      <div>
        <p className="text-sm/6 mt-4 text-gray-600">{description}</p>
        {onClick ? (
          <button
            onClick={onClick}
            className={classNames(
              "w-full self-end bg-sky-600 text-white shadow-sm hover:bg-sky-500",
              "text-sm/6 mt-6 block rounded-md px-3 py-2 text-center font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600",
              "border-0"
            )}
          >
            Sign Up
          </button>
        ) : (
          <a
            href={href}
            className={classNames(
              "w-full self-end bg-sky-600 text-white shadow-sm hover:bg-sky-500",
              "text-sm/6 mt-6 block rounded-md px-3 py-2 text-center font-semibold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600",
              "hover:text-white"
            )}
          >
            Sign Up
          </a>
        )}
      </div>
    </div>
  )
}

export default Card
